export default {"src":"/_next/static/media/icon-count-unions.752bdf55.svg","height":450,"width":512};